__webpack_public_path__ = window.additionalServerData?.config?.CDN_PUBLIC_PATH ?? '/'
